export enum CtaTextEnum {
  allow = 'ALLOW',
  get = 'GET',
  getUpdates = 'GET_UPDATES',
  optIn = 'OPT_IN',
  signUp = 'SIGN_UP',
}
